export const getYouTubeId = (value) => {
  if (!value || typeof value !== 'string') return null;

  const input = value.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(input)) return input;

  try {
    const url = new URL(input);
    if (url.hostname === 'youtu.be') {
      return url.pathname.slice(1).split('/')[0] || null;
    }
    if (url.hostname.endsWith('youtube.com')) {
      if (url.pathname === '/watch') return url.searchParams.get('v');
      if (url.pathname.startsWith('/embed/')) return url.pathname.split('/')[2] || null;
      if (url.pathname.startsWith('/shorts/')) return url.pathname.split('/')[2] || null;
      if (url.pathname.startsWith('/live/')) return url.pathname.split('/')[2] || null;
    }
  } catch {
    return null;
  }

  return null;
};

export const getYouTubeIdFromBlock = (value) => {
  const video = value?.video ?? value;
  if (typeof video === 'string') return getYouTubeId(video);
  return getYouTubeId(video?.id || video?.url || video?.value);
};
